import React, { useCallback, useEffect, useMemo, useState } from "react";
import DataTable from "react-data-table-component";
import { jdsTableStyles } from "../../components/jds/tableStyles";
import { jdsSelectProps } from "../../components/jds/selectProps";
import { JdsPagination } from "../../components/jds/JdsPagination";
import "../../components/jds/jds.css";
import "./users.css";
import { getUsers } from "../../api";
import * as S from "./Users.styles";
import { columns } from "./columns";
import { LINK_TYPE_OPTIONS, STATUS_OPTIONS } from "./constants";

const Users = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);

  const [filters, setFilters] = useState({
    name: "",
    email: "",
    linkType: null,
    status: null,
  });

  const [pagination, setPagination] = useState({
    page: 1,
    perPage: 10,
  });

  const fetchUsers = useCallback(async () => {
    setLoading(true);
    try {
      const response = await getUsers({
        page: pagination.page,
        perPage: pagination.perPage,
        name: filters.name,
        email: filters.email,
        linkType: filters.linkType?.id,
        status: filters.status?.id,
      });

      setData(response.data.data);
      setTotalRows(response.data.total);
    } finally {
      setLoading(false);
    }
  }, [pagination, filters]);

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
    setPagination((prev) => ({ ...prev, page: 1 }));
  };

  const handlePageChange = (page) => {
    setPagination((prev) => ({ ...prev, page }));
  };

  const handlePerPageChange = (newPerPage, page) => {
    setPagination({ page, perPage: newPerPage });
  };

  const subHeaderComponent = useMemo(() => (
    <S.FiltersContainer>
      <span className="users-filters__label">Filtrar por:</span>
      <S.FiltersWrapper>
        <div>
          <S.Input
            type="text"
            placeholder="Nome"
            aria-label="Filtrar por nome"
            className="form-control"
            value={filters.name}
            onChange={(e) => handleFilterChange("name", e.target.value)}
          />
        </div>
        <div>
          <S.Input
            type="text"
            placeholder="E-mail"
            aria-label="Filtrar por e-mail"
            className="form-control"
            value={filters.email}
            onChange={(e) => handleFilterChange("email", e.target.value)}
          />
        </div>
        <div>
          <S.CustomSelect
            name="link_type_select"
            isSearchable={false}
            options={LINK_TYPE_OPTIONS}
            {...jdsSelectProps}
            aria-label="Filtrar por vínculo"
            onChange={(option) => handleFilterChange("linkType", option)}
            value={filters.linkType}
            placeholder="Vínculo"
            getOptionLabel={(option) => option.name}
            getOptionValue={(option) => option.id}
            hideSelectedOptions
            isClearable
          />
        </div>
        <div>
          <S.CustomSelect
            name="status_select"
            isSearchable={false}
            options={STATUS_OPTIONS}
            {...jdsSelectProps}
            aria-label="Filtrar por status"
            onChange={(option) => handleFilterChange("status", option)}
            value={filters.status}
            placeholder="Status"
            getOptionLabel={(option) => option.name}
            getOptionValue={(option) => option.id}
            hideSelectedOptions
            isClearable
          />
        </div>
      </S.FiltersWrapper>
    </S.FiltersContainer>
  ), [filters]);

  return (
    <div className="jds-scope">
      <h1 className="jds-title-lg">Usuários</h1>
      <p className="text-muted mb-10">Listagem de todos os usuários</p>

      <div className="jds-card jds-card--flush">
        <div style={{ overflowX: "auto", width: "100%" }}>
          <DataTable
            columns={columns}
            data={data}
            customStyles={jdsTableStyles}
            progressPending={loading}
            pagination
            paginationServer
            paginationTotalRows={totalRows}
            onChangePage={handlePageChange}
            onChangeRowsPerPage={handlePerPageChange}
            subHeader
            subHeaderAlign="left"
            subHeaderComponent={subHeaderComponent}
            paginationComponent={JdsPagination}
            responsive={false}
            style={{ width: "100%" }}
          />
        </div>
      </div>
    </div>
  );
};

export default Users;
